import React, { useState } from 'react';
import axios from 'axios';

const FreelancerCompleteInfoPage = () => {
  const [freelancerId, setFreelancerId] = useState('');
  const [freelancerData, setFreelancerData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const handleFetch = async () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('employeeToken');
    if (!token) {
      window.location.href = "/employee-login";
      return;
    }

    try {
      const response = await axios.get(`${apiBaseURL}/api/freelancer-complete-info/${freelancerId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setFreelancerData(response.data);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  // Helper function to format ISO date strings to readable IST format
  const formatDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return '';
    if (!dateString.includes('T')) return dateString; // not a date string
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const RenderTable = ({ title, data }) => {
    const isArray = Array.isArray(data);
    const normalizedData = isArray ? data : [data];
    const hasData = normalizedData && normalizedData.length > 0 && Object.keys(normalizedData[0]).length > 0;
    const columns = hasData ? Object.keys(normalizedData[0]) : ["No Data"];

    return (
      <div className="mb-4 bg-white shadow p-4 rounded">
        <h3 className="text-lg font-semibold capitalize mb-2">{title}</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border text-sm">
            <thead>
              <tr className="bg-gray-200">
                {columns.map((col, idx) => (
                  <th key={idx} className="px-4 py-2 text-left border">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {hasData ? (
                normalizedData.map((row, i) => (
                  <tr key={i} className="border-b">
                    {columns.map((col, j) => {
                      const value = row[col];
                      const displayValue =
                        typeof value === 'string' && value.includes('T') && value.includes('Z')
                          ? formatDate(value)
                          : String(value ?? '');
                      return (
                        <td key={j} className="px-4 py-2 border">{displayValue}</td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="px-4 py-2 text-center border text-gray-500">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1 p-6 bg-gray-100 ml-64">
      <h2 className="text-2xl font-semibold mb-4">Freelancer Complete Info</h2>

      <div className="mb-4 flex items-center space-x-2">
        <input
          type="text"
          placeholder="Enter Freelancer ID"
          value={freelancerId}
          onChange={(e) => setFreelancerId(e.target.value)}
          className="border border-gray-300 px-3 py-1 rounded"
        />
        <button
          onClick={handleFetch}
          className="bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700"
        >
          Fetch Info
        </button>
      </div>

      {loading && <div>Loading data...</div>}
      {error && <div className="text-red-500">{error}</div>}

      {freelancerData &&
        Object.entries(freelancerData).map(([section, data]) => (
          <RenderTable key={section} title={section} data={data} />
        ))}
    </div>
  );
};

export default FreelancerCompleteInfoPage;
